export const publicaColors = {
  // colors labeled as is
  black: '#000000',
  white: '#FFFFFF',
  blue: '#4952FF',
  teal: '#4FC1B5',
  green: '#3FD077',
  darkGreen: '#00B42A',
  veryLightGreen: '#E8FFEA',
  yellow: '#FEE72F',
  darkGoldenRod: '#b8860b',
  red: '#FA0E0E',
  veryLightRed: '#FFECE8',
  pink: '#FA0E0E24',
  purple: '#B55DF5',
  darkPurple: '#95619C',
  ivory: '#FEFFF4',
  iceWhite: '#f0f4fc',
  whiteOrchid: '#f8fafe',
  lightBlue: '#5D66FA',
  lighterBlue: '#EDEEFF',
  veryLightBlue: '#F8FAFF', // bgcolor
  darkBlue: '#0009B4',
  eyeBlue: '#00b7a930',
  skyBlue: '#E1F4FF',
  lightTeal: '#51c3b5',
  lighterYellow: '#fcfcde',
  turquoise: '#00B7A9',
  lightTurquoise: '#A3EAE4',
  honeydew: '#D9F6ED',
  jungleGreen: '#00C488',
  navy: '#273653',
  tan: '#C6AC8F',
  lavender: '#E0E3FF',
  mahogany: '#A75E6E',
  orange: '#F3A916',
  lightOrange: '#ffa50033',
  veryLightOrange: '#f4b5831a',
  lighterGreen: '#EEFEFC',
  maroon: '#B31212',
  // sticker colors
  lightGreen: '#3cd079',
  mint: '#e8fcf4',
  lightYellow: '#ffeb2f',
  veryLightYellow: '#fffce4',
  kojiOrange: '#f2ae4961',
  lightRed: '#ff0d0d',
  lightPurple: '#b55ef8',
  lightLilac: '#E8C2D233',
  // gray scale
  veryDarkGray: '#292F36',
  darkGray: '#434343',
  gray: '#707070',
  mediumGray: '#BDBDBD',
  mediumLightGray: '#929599',
  lightGray: '#E0E0E0',
  lighterGray: '#F2F2F2',
  veryLightGray: '#f6f6f6',
  veryLightPurple: '#D9B8FF',
};

export const graphColors: Record<string, string> = {
  blue: '#4952FF',
  blueGrey: '#84BCEF',
  coralPink: '#FB6376',
  cyan: '#ACF8F4',
  darkBlue: '#014F86',
  darkGreen: '#00B42A',
  darkNavy: '#00324a',
  darkPeach: '#F4B583',
  deepLilac: '#A34FC2',
  fluorescentPink: '#FF66FF',
  forestGreen: '#40916C',
  green: '#3FD077',
  lavender: '#DAC3E8',
  lavenderPurple: '#6F60DD',
  lightBlue: '#454eff',
  lightGreen: '#3cd079',
  lightLavendar: '#8377D1',
  lightOrange: '#FF9900',
  lightPink: '#FFB6C1',
  lightPurple: '#b55ef8',
  lightRed: '#ff0d0d',
  lightTeal: '#51c3b5',
  lightYellow: '#ffeb2f',
  lightblue: '#5D66FA',
  limeGreen: '#B2E061',
  magentaDye: '#D30C7B',
  mahogany: '#A75E6E',
  mustard: '#F3C628',
  orange: '#FFA737',
  palePink: '#E8C2D2',
  paleYellow: '#FFFD82',
  pink: '#FF9CEF',
  purple: '#B55DF5',
  purpleBlue: '#95619C',
  red: '#FA0E0E',
  redOrange: '#FF4E29',
  seaGreen: '#85FFC7',
  sienna: '#E88160',
  slateGrey: '#8E9AAF',
  teal: '#4FC1B5',
  turquoise: '#00B7A9',
  yellow: '#FEE72F',
};

export const IntegralPlatformColors = {
  darkGray: '#335b6e',
  goldenrod: '#e6b710',
  indigo: '#4e62e0',
  lightGray: '#8099a5',
  midnight: '#00324a',
  orchid: '#acb7ff',
  red: '#f03827',
  turquoise: '#00b7a9',
  yellow: '#ffd12b',
};

export const muiColors = {
  checkbox: '#354975',
};
